var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var loaders = require('../../layout/components/loaders');
var flash = require('../../components/flash');
var templateModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


templateModal.editDialogue = function (record, options) {

  templateModal.deviceId = prop('')
  templateModal.template = prop('')
  templateModal.errors = []

  var submit = () => {
    templateModal.errors = [];
    var rawTemplate = String(templateModal.template() || '').trim();
    var parsedTemplate;

    if (!rawTemplate) {
      templateModal.errors = ['Template JSON is required.'];
      m.redraw();
      return false;
    }

    try {
      parsedTemplate = JSON.parse(rawTemplate);
    } catch (error) {
      templateModal.errors = ['Template JSON is invalid. Fix JSON errors before saving.'];
      m.redraw();
      return false;
    }

    return loaders.requestWithLoader({
      url: "/api/v1/dashboard/template",
      method: "POST",
      body: {
        parentDashboardId: record['@rid'].slice(1),
        template: parsedTemplate,
        deviceId: templateModal.deviceId()
      }
    })
    .then(function (result) {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
    .catch(function (error) {
      templateModal.errors = [getRequestErrorMessage(error) || 'Unable to load elements from template.'];
      m.redraw();
      throw error;
    });
  };
  
  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title('New Template: ')
  modal.vm.body = templateModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open();
}


templateModal.view = function () {
  return m('form', {role:'form'}, [
    m(flash, {items: templateModal.errors, bg: 'bg-red'}),
    m('label', 'Device Id:'),
    m('input.form-control', {
      autocomplete: 'off',
      type:'text', 
      oninput: function(ev){templateModal.deviceId(ev.target.value)},
      value: templateModal.deviceId(),
    }),
    m('label', {for:'comment'}, 'Template:'),
    m('div.flex.mt2',[
      m('textarea', {
        resize: 'none',
        id:'comment',
        rows:'5',
        cols:'40', 
        'box-sizing': 'border-box',
        placeholder:"Add your template here...",
        oninput: function(ev){templateModal.template(ev.target.value)},
        value: templateModal.template()
      })
    ])
  ])  
}

function getRequestErrorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (typeof error.error === 'string' && error.error) return error.error;
  if (typeof error.message === 'string' && error.message) return error.message;
  if (Array.isArray(error.errors) && error.errors.length) {
    return typeof error.errors[0] === 'string' ? error.errors[0] : '';
  }
  return '';
}

module.exports = templateModal;
